<div id="videoContainerComponentId">
  <div
    class="no-media-preview-container"
    *ngIf="!!media ? media.mediaLinkedType === 3 : false"
  >
    No Media To Preview
  </div>
  <div
    class="videoContainer"
    *ngIf="!!media ? media.mediaLinkedType !== 3 : true"
  >
    <div class="indicators" [ngClass]="{ fullscreen: isFullScreen }">
      <span
        *ngIf="duringRecording"
        class="animate-recording"
        inlineSVG="/assets/icons/recording-start.svg"
      ></span>
      <h3 *ngIf="showTimecode">
        {{ timecodeValue | timecode: framerate : timecodeFormatting }}
      </h3>
    </div>

    <!-- Video TAG -->
    <video
      *ngIf="checkIfHlsFormat()"
      poster="{{ posterUrl }}"
      [icn-hls-src]="videoUrl"
      preload="auto"
      [autoStart]="false"
      (error)="onError($event)"
      (canplay)="onCanPlay($event)"
      (timeupdate)="onTimeupdate($event)"
      (play)="onPlay($event)"
      (pause)="onPause()"
      (ended)="onEnded($event)"
      (loadstart)="onLoadingStart($event)"
      (progress)="onLoading($event)"
      [currentTime]="startTime"
      [autoplay]="autoPlay"
    ></video>

    <video
      *ngIf="checkIfHlsFormat() === false"
      poster="{{ posterUrl }}"
      src="{{ videoUrl }}"
      preload="auto"
      (error)="onError($event)"
      (canplay)="onCanPlay($event)"
      (timeupdate)="onTimeupdate($event)"
      (play)="onPlay($event)"
      (pause)="onPause()"
      (ended)="onEnded($event)"
      (loadstart)="onLoadingStart($event)"
      (progress)="onLoading($event)"
      [currentTime]="startTime"
      [autoplay]="autoPlay"
    ></video>

    <!-- Video Loader -->
    <div class="video-loader" *ngIf="!ready">
      <svg width="26.5" height="26.5" viewBox="0 0 46 46">
        <path
          class="background"
          d="M22.499 1.499c11.598 0 21 9.403 21 21 0 11.598-9.402 21-21 21s-21-9.402-21-21c0-11.597 9.402-21 21-21z"
        />
        <path
          class="top"
          d="M22.499 1.499c11.598 0 21 9.403 21 21 0 11.598-9.402 21-21 21s-21-9.402-21-21c0-11.597 9.402-21 21-21z"
        />
      </svg>

      <div class="slow-internet-message" *ngIf="true || slowConnection">
        <span>Loading is Taking too much Time</span>
        <p>
          please make sure your internet connection is working well. if the
          issue still occurs, please contact us.
        </p>
      </div>
    </div>

    <!-- Video error message -->
    <div class="video-error" *ngIf="isError">
      <span>An error occurred. Please try again</span>
      <a href="http://www.evrideo.com/video-error" target="_blank"
        >Learn More</a
      >
    </div>

    <!-- Audio Selection -->
    <ul class="hidden"></ul>

    <div class="subtitles-container" [ngClass]="{ rtlSubtitle: rtlSubtitle }">
      <span [innerHtml]="subtitleText" [ngStyle]="subtitlesStyle"></span>
    </div>
  </div>

  <!-- Audio Selection -->
  <ul
    [ngClass]="{ hidden: !(audioOpen || subtitlesOpen || timecodeFormatOpen) }"
  >
    <li>
      <radio-collection
        [options]="onVideoOptions"
        (output)="onSelectVideoOption($event)"
      ></radio-collection>
    </li>
  </ul>
  <div class="controls">
    <button id="play" (click)="playToggle($event)" [disabled]="!ready">
      <svg width="10px" height="12px" [ngClass]="{ hidden: playing }">
        <path
          fill-rule="evenodd"
          fill="rgb(125, 143, 161)"
          d="M0.896,11.812 C0.741,11.812 0.586,11.772 0.446,11.691 C0.165,11.533 -0.002,11.249 -0.002,10.933 L-0.002,1.680 C-0.002,1.364 0.165,1.080 0.446,0.921 C0.726,0.764 1.062,0.764 1.344,0.920 L9.550,5.547 C9.832,5.705 9.999,5.990 9.999,6.306 C9.999,6.624 9.832,6.907 9.550,7.066 L1.345,11.692 C1.205,11.772 1.049,11.812 0.896,11.812 ZM1.005,1.866 L1.005,10.747 L8.882,6.306 L1.005,1.866 Z"
        />
      </svg>

      <svg
        width="8px"
        height="10px"
        viewBox="0 0 8 10"
        [ngClass]="{ hidden: !playing }"
      >
        <g>
          <path
            d="M2.3,10H.6A.6.6,0,0,1,0,9.3V.7A.6.6,0,0,1,.6,0H2.3A.7.7,0,0,1,3,.7V9.3A.7.7,0,0,1,2.3,10ZM.9,9H2V1H.9Z"
            fill="rgb(125, 143, 161)"
          />
          <path
            d="M7.3,10H5.6A.6.6,0,0,1,5,9.3V.7A.6.6,0,0,1,5.6,0H7.3A.7.7,0,0,1,8,.7V9.3A.7.7,0,0,1,7.3,10ZM5.9,9H7V1H5.9Z"
            fill="rgb(125, 143, 161)"
          />
        </g>
      </svg>
    </button>
    <button
      *ngIf="showTrimBrackets && media"
      (click)="playTrimmed()"
      [disabled]="!ready"
      class="play-trimmed"
    >
      <svg width="10px" height="12px">
        <path
          fill-rule="evenodd"
          fill="rgb(125, 143, 161)"
          d="M0.896,11.812 C0.741,11.812 0.586,11.772 0.446,11.691 C0.165,11.533 -0.002,11.249 -0.002,10.933 L-0.002,1.680 C-0.002,1.364 0.165,1.080 0.446,0.921 C0.726,0.764 1.062,0.764 1.344,0.920 L9.550,5.547 C9.832,5.705 9.999,5.990 9.999,6.306 C9.999,6.624 9.832,6.907 9.550,7.066 L1.345,11.692 C1.205,11.772 1.049,11.812 0.896,11.812 ZM1.005,1.866 L1.005,10.747 L8.882,6.306 L1.005,1.866 Z"
        />
      </svg>
      <span>[</span>
    </button>
    <section class="progress-bar">
      <i (click)="seek($event)" #durationElement>
        <span [ngStyle]="{ width: duration + '%' }"></span>
        <i [ngStyle]="{ transform: overDurationRule }"></i>

        <span
          class="time-tooltip"
          #durationTooltip
          [ngClass]="{ visible: durationTooltipVisible }"
          [ngStyle]="{ transform: 'translateX(' + durationTooltipX + 'px)' }"
          >{{ overDurationTxt | duration }}</span
        >
        <b
          class="bracket start"
          *ngIf="showTrimBrackets && media"
          (mousedown)="onTrimInMouseDown($event)"
          (mouseenter)="onTrimMouseEnter($event)"
          [ngStyle]="{
            transform: 'translateX(' + calculatedTrinInOffset + 'px)',
            width: trimBracketWidth + 'px'
          }"
          >[</b
        >
        <b
          class="bracket end"
          *ngIf="showTrimBrackets && media"
          (mousedown)="onTrimOutMouseDown($event)"
          (mouseenter)="onTrimMouseEnter($event)"
          [ngStyle]="{
            transform: 'translateX(' + calculatedTrinOutOffset + 'px)',
            width: trimBracketWidth + 'px'
          }"
          >]</b
        >
      </i>
    </section>

    <button id="volume" (click)="muteToggle($event)">
      <svg width="15px" height="15px" [ngClass]="{ hidden: muted }">
        <path
          fill-rule="evenodd"
          fill="rgb(125, 143, 161)"
          d="M11.954,9.711 L11.954,8.692 C12.672,8.692 13.257,8.111 13.257,7.398 C13.257,6.684 12.672,6.104 11.954,6.104 L11.954,5.085 C13.238,5.085 14.282,6.123 14.282,7.398 C14.282,8.673 13.238,9.711 11.954,9.711 ZM9.552,14.889 C9.272,15.048 8.936,15.048 8.654,14.891 L4.805,11.783 C4.680,11.915 4.505,12.000 4.309,12.000 L0.681,12.000 C0.302,12.000 -0.007,11.691 -0.007,11.311 L-0.007,3.684 C-0.007,3.305 0.302,2.996 0.681,2.996 L4.309,2.996 C4.509,2.996 4.685,3.085 4.811,3.222 L8.653,0.119 C8.794,0.040 8.949,-0.001 9.102,-0.001 C9.257,-0.001 9.411,0.040 9.552,0.119 C9.833,0.278 10.000,0.562 10.000,0.878 L10.000,14.131 C10.000,14.447 9.833,14.731 9.552,14.889 ZM1.016,4.019 L1.016,10.977 L3.808,10.977 L3.823,4.019 L1.016,4.019 ZM8.993,1.064 L4.997,4.332 L4.997,10.678 L8.993,13.945 L8.993,1.064 Z"
        />
      </svg>

      <svg width="14.4px" height="16.6px" [ngClass]="{ hidden: !muted }">
        <g>
          <path
            d="M9.6,16.2a.9.9,0,0,1-.9,0L4.8,13.1l-.5.2H.7a.7.7,0,0,1-.7-.7V5a.7.7,0,0,1,.7-.7H4.3l.5.2L8.7,1.4h.9a.9.9,0,0,1,.4.8V15.4A.9.9,0,0,1,9.6,16.2ZM4,5.3H1v7H4M9,2.4,5,5.6V12l4,3.3Z"
            fill="rgb(125, 143, 161)"
            style="fill-rule: evenodd"
          />
          <rect
            x="7"
            y="-2"
            width="1"
            height="20.62"
            transform="translate(-3.6 6.6) rotate(-39.1)"
            fill="rgb(125, 143, 161)"
          />
        </g>
      </svg>
    </button>

    <button
      id="audio"
      [ngClass]="{ active: audioOpen || shouldPlayAudioTrack }"
      [disabled]="!audio?.length"
      (click)="audioToggle($event)"
    >
      <svg width="15" height="15" viewBox="0 0 17 17">
        <path
          fill-rule="evenodd"
          d="M5 2v10.515A2.47 2.47 0 0 0 3.5 12h-1A2.507 2.507 0 0 0 0 14.5C0 15.875 1.125 17 2.5 17h1c1.204 0 2.267-.863 2.5-2V6.818l9-1.636v5.333A2.47 2.47 0 0 0 13.5 10h-1a2.507 2.507 0 0 0-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5h1c1.204 0 2.267-.862 2.5-2V0L5 2zM3.5 16h-1c-.827 0-1.5-.673-1.5-1.5S1.673 13 2.5 13h1c.827 0 1.5.673 1.5 1.5S4.327 16 3.5 16zm10-2h-1c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5h1c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5zM15 4.182L6 5.818v-3l9-1.636v3z"
        />
      </svg>
    </button>

    <button
      id="subtitles"
      [ngClass]="{ active: subtitlesOpen || subtitle }"
      [disabled]="!subtitles?.length && !closedCaptions?.length"
      (click)="subtitlesToggle($event)"
    >
      <svg width="15" height="15" viewBox="0 0 19 19">
        <path
          fill="#7D8FA1"
          fill-rule="evenodd"
          d="M4 3H3v1h1V3zm3 0H6v1h1V3zm3 0H9v1h1V3zm3 0h-1v1h1V3zm3 0h-1v1h1V3zM4 14H3v1h1v-1zm3 0H6v1h1v-1zm3 0H9v1h1v-1zm3 0h-1v1h1v-1zm3 0h-1v1h1v-1zm1.288-13H1.712A.712.712 0 0 0 1 1.711v14.578c0 .392.319.711.712.711h15.576a.712.712 0 0 0 .712-.711V1.711A.712.712 0 0 0 17.288 1m0-1C18.23 0 19 .77 19 1.711v14.578C19 17.23 18.23 18 17.288 18H1.712C.77 18 0 17.23 0 16.289V1.711C0 .77.77 0 1.712 0h15.576zM15 8H4V7h11v1zm-2 2H6V9h7v1z"
        />
      </svg>
    </button>
    <button
      id="timecodeFormat"
      [ngClass]="{ active: timecodeFormatOpen }"
      [disabled]="!showTimecode"
      (click)="timecodeFormatToggle($event)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="timecode-svg"
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#7D8FA1"
        stroke-width=".5"
        stroke-linecap="square"
        stroke-linejoin="round"
      >
        <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
        <line x1="7" y1="2" x2="7" y2="22"></line>
        <line x1="17" y1="2" x2="17" y2="22"></line>
        <line x1="2" y1="12" x2="22" y2="12"></line>
        <line x1="2" y1="7" x2="7" y2="7"></line>
        <line x1="2" y1="17" x2="7" y2="17"></line>
        <line x1="17" y1="17" x2="22" y2="17"></line>
        <line x1="17" y1="7" x2="22" y2="7"></line>
      </svg>
    </button>
    <button id="fullScreen" (click)="fullScreen()" [disabled]="!ready">
      <svg width="12px" height="12px">
        <path
          fill-rule="evenodd"
          fill="rgb(125, 143, 161)"
          d="M11.310,12.000 L6.995,12.000 L6.995,10.976 L10.975,10.976 L10.975,6.996 L11.999,6.996 L11.999,11.311 C11.999,11.691 11.690,12.000 11.310,12.000 ZM10.975,1.020 L6.995,1.020 L6.995,-0.004 L11.310,-0.004 C11.690,-0.004 11.999,0.305 11.999,0.684 L11.999,4.999 L10.975,4.999 L10.975,1.020 ZM-0.005,11.311 L-0.005,6.996 L1.019,6.996 L1.019,10.976 L4.999,10.976 L4.999,12.000 L0.683,12.000 C0.304,12.000 -0.005,11.691 -0.005,11.311 ZM1.019,4.999 L-0.005,4.999 L-0.005,0.684 C-0.005,0.305 0.304,-0.004 0.683,-0.004 L4.999,-0.004 L4.999,1.020 L1.019,1.020 L1.019,4.999 Z"
        />
      </svg>
    </button>
  </div>

  <!-- Audio tag -->
  <audio
    #audioTrack
    preload="auto"
    (canplay)="onAudioTrackReady($event)"
  ></audio>
</div>
